// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollPatientResponse {
    static getAttributeTypeMap() {
        return EnrollPatientResponse.attributeTypeMap;
    }
}
EnrollPatientResponse.discriminator = undefined;
EnrollPatientResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnrollmentV2ProcessingResultModel"
    }
];
//# sourceMappingURL=enrollPatientResponse.js.map